import React, { ReactNode } from 'react'

type CommentaryCommonBoxProps = {
  title: string
  children: ReactNode
  className?: string
  id?: string
}

const CommentaryCommonBox = ({ title, children, className = '', id }: CommentaryCommonBoxProps) => {
  return (
    <section className={` ${className} p-4 bg-card rounded-2xl mb-3`} id={id}>
      <div className={``}>
        <p className="text-primary-500 font-bold mb-0">{title}</p>
      </div>
      <div className={``}>
        <p className="mb-0 text-t-600">{children}</p>
      </div>
    </section>
  )
}

export default CommentaryCommonBox
